import { LEADTIME_MONTH_UNIT, LEADTIME_WEEK_UNIT } from './constants';

/**
 * リードタイムの値をunitに合わせて表示用に変換する
 * @param leadTime - リードタイム
 * @param leadTimeUnit - リードタイムの単位
 * ex) leadTime = 75, leadTimeUnit = "month" => 2.5
 */
export const convertLeadTimeByUnit = (leadTime: number, leadTimeUnit: string) => {
  let output = -1;
  if (leadTime < 0) return output;

  if (leadTimeUnit === 'ヶ月' || leadTimeUnit === 'month') {
    output = (Math.floor((leadTime / LEADTIME_MONTH_UNIT) * 10) / 10) as number;
  }
  if (leadTimeUnit === '週' || leadTimeUnit === 'week') {
    output = Math.floor(leadTime / LEADTIME_WEEK_UNIT) as number;
  }
  if (leadTimeUnit === '日' || leadTimeUnit === 'day') {
    output = leadTime;
  }
  return output;
};

/**
 * リードタイムの値をunitからバックエンド用に変換する
 * @param leadTime - リードタイム
 * @param leadTimeUnit - リードタイムの単位
 * ex) leadTime = 75, leadTimeUnit = "month" => 2.5
 */
export const convertLeadTimeToDays = (leadTime: number, leadTimeUnit: string) => {
  let output = -1;
  if (leadTime < 0) return output;

  if (leadTimeUnit === 'ヶ月' || leadTimeUnit === 'month') {
    output = (leadTime * LEADTIME_MONTH_UNIT) as number;
  }
  if (leadTimeUnit === '週' || leadTimeUnit === 'week') {
    output = (leadTime * LEADTIME_WEEK_UNIT) as number;
  }
  if (leadTimeUnit === '日' || leadTimeUnit === 'day') {
    output = leadTime;
  }
  return output;
};

/**
 * リードタイムの値と単位をまとめたインターフェース
 * @property {number} value - 値
 * @property {string} unit - 単位
 */
export interface ILeadTimeInfo {
  value: number;
  unit: string;
}
